import clsx from "clsx";
import BodyText from "components/BodyText";
import Target from "components/Target";
import TargetIcon from "components/TargetIcon";
import React from "react";

const BlockList = ({ children }) => {
  return (
    <div className={clsx("BlockList")}>
      <div className={clsx("BlockList__blocks", "")}>{children}</div>
    </div>
  );
};

const Block = ({ heading, text, number = null, target = null }) => {
  return (
    <Target className={clsx("BlockList__block", "group")} target={target}>
      <div
        className={clsx(
          "BlockList__content",
          "group block border-b py-5 group-last-of-type:border-b-0",
        )}
      >
        <div className={clsx("BlockList__header", "flex space-x-1")}>
          <div className={clsx("BlockList__indicatorWrapper", "mb-3")}>
            <div
              className={clsx(
                "BlockList__indicator",
                "flex h-9 w-9 items-center justify-center rounded-full bg-sky-500 font-medium text-white",
              )}
            >
              {number}
            </div>
          </div>
          {!!target && !!target.url && (
            <div
              className={clsx(
                "BlockList__icon",
                "flex h-9 w-9 items-center justify-center rounded-full bg-gray-300/75 transition-colors group-hover:bg-gray-300/100",
              )}
            >
              <TargetIcon target={target} />
            </div>
          )}
        </div>
        <div
          className={clsx("BlockList__heading", "font-medium text-gray-800")}
        >
          {heading}
        </div>
        <div className={clsx("BlockList__text")}>
          <BodyText text={text} />
        </div>
      </div>
    </Target>
  );
};

BlockList.Block = Block;

export default BlockList;
